import React from "react";
import AuthenticatedLayout from "../components/AuthenticatedLayout";
import ResultsGrid from "../components/ResultsGrid";
import PageTitle from "../components/PageTitle";
import { defaultSort, getColumns } from "../data/results";
import ResultsGraph from "../components/ResultsGraph";
import _ from "lodash";
import { Select, MenuItem } from "@material-ui/core";
import {
  getResultsData,
  ResultsData,
  getStats,
  getYears,
} from "../data/results_data";

interface ResultsProps {}

const Results = ({}: ResultsProps) => {
  const [year, setYear] = React.useState<number>(new Date().getFullYear());
  const [results, setResults] = React.useState<ResultsData>({
    headers: [],
    data: [],
  });

  React.useEffect(() => {
    setResults(getResultsData(year));
  }, [year]);

  const datePicker = ({}) => {
    const years = getYears().map((y) => (
      <MenuItem key={`year_${y}`} value={y}>
        {y}
      </MenuItem>
    ));

    return (
      <Select
        value={year}
        onChange={(e) => setYear(parseInt(String(e.target.value)))}
      >
        {years}
      </Select>
    );
  };

  return (
    <AuthenticatedLayout>
      <React.Fragment>
        <PageTitle text="Results" render={datePicker} />
        <ResultsGrid
          year={year}
          columns={getColumns(year)}
          rowData={results.data}
          defaultSort={defaultSort(year)}
        />
        <ResultsGraph
          columns={getColumns(year)}
          rowData={results.data}
          stats={getStats(year)}
        />
      </React.Fragment>
    </AuthenticatedLayout>
  );
};

export default Results;
